import { Item } from '@react-stately/collections'

import { Select } from 'components/Select/Select'
import Styles from './HandbookSettings.module.scss'
import { HandbookViewMode } from 'types'
import { PreferencesProps } from './Types'
import { RadioButtons } from 'components/RadioButton/RadioButtons'

const Preferences = ({ handbook, onUpdate, isUpdating }: PreferencesProps) => {
  return (
    <>
      {!handbook.folder && (
        <div className={Styles.mb32}>
          <div className={Styles.label}>Sharing Setting</div>
          <RadioButtons
            isDisabled={isUpdating}
            onSelectionChange={(key) => onUpdate({ cascading_share: key === 'true' })}
            selectedKey={handbook.cascading_share ? 'true' : 'false'}
            options={[
              {
                key: 'true',
                title: 'Handbook users automatically have access to all docs within the handbook (Default)',
                description:
                  'E.g. If I add Michael Scott to the handbook, Michael has access to all the docs within the handbook.',
              },
              {
                key: 'false',
                title: 'Access to docs within the handbook are granted independently from the handbook',
                description:
                  'E.g. If I add Michael Scott to the handbook, Michael still must request access to docs he doesn’t have access to.',
              },
            ]}
          />
        </div>
      )}

      <div className={Styles.row}>
        <div>
          <label id="view-mode-label" className={Styles.label}>
            Default view of docs within {handbook.folder ? 'folder' : 'handbook'}
          </label>
          <div className={Styles.subLabel}>
            Choose which view is shown by default when a user selects a doc from this{' '}
            {handbook.folder ? 'folder' : 'handbook'}. Readers and commenters can still suggest changes.
          </div>
        </div>
        <div className={Styles.selectContainer}>
          <Select
            aria-labelledby="view-mode-label"
            isDisabled={isUpdating}
            selectedKey={handbook.view_mode}
            size="sm"
            onSelectionChange={(mode) => {
              if (mode && mode !== handbook.view_mode) onUpdate({ view_mode: mode as HandbookViewMode })
            }}
          >
            <Item key={HandbookViewMode.Read}>Read Only</Item>
            <Item key={HandbookViewMode.Comment}>Comment</Item>
            <Item key={HandbookViewMode.Edit}>Edit</Item>
          </Select>
        </div>
      </div>
    </>
  )
}

export { Preferences }
